export default __webpack_public_path__ + "static/media/avatar-3.72c91599.jpg";